<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
    viewBox="0 0 24 24"
  >
    <g fill="none" fill-rule="evenodd">
      <g fill="#2C4A7D">
        <path
          d="M8.75 0l3 4H23v14.5c0 1.38-1.12 2.5-2.5 2.5h-18C1.12 21 0 19.88 0 18.5V0h8.75zm-.5 1H1v17.5c0 .78.595 1.42 1.356 1.493L2.5 20h18c.828 0 1.5-.672 1.5-1.5V5H11.25l-3-4zM12 8v5h5v1h-6V8h1z"
          transform="translate(1 2)"
        />
      </g>
    </g>
  </svg>
</template>

<script>
import VueTypes from 'vue-types';
export default {
  name: 'SyncHistoryIcon',
  props: {
    height: VueTypes.string.def('24'),
    width: VueTypes.string.def('24'),
  },
};
</script>

<style lang="scss"></style>
